import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import { AdEntitiesState } from '../interfaces/adEntities';
import { AdSetWithRelationsModel } from '../model/AdSetModel';
import { AdModel, AdSyncModel } from '../model/AdModel';

const initialState = {
  busy: false,
  adSets: {},
  ads: {},
  syncedAds: {},
};

type RetrievedAction<T> = {
  payload: {
    id: string;
    data: T[];
    next: string | null;
  };
  type: string;
};

const retrievedData = <T>(
  action: RetrievedAction<T>,
  state: AdEntitiesState,
  key: 'adSets' | 'ads' | 'syncedAds',
) => {
  const {
    payload: { id },
  } = action;
  return {
    ...state,
    [key]: {
      ...state[key],
      [id]: {
        data: [
          ...(state[key][id] || { data: [] }).data,
          ...action.payload.data,
        ],
        next: action.payload.next,
      },
    },
  };
};

export default function adEntities(state = initialState, action: any) {
  switch (action.type) {
    case Actions.RETRIEVED_AD_SETS:
      return retrievedData<AdSetWithRelationsModel>(action, state, 'adSets');
    case Actions.RETRIEVED_ADS:
      return retrievedData<AdModel>(action, state, 'ads');
    case Actions.RETRIEVED_SYNCED_ADS:
      return retrievedData<AdSyncModel>(action, state, 'syncedAds');
    case Actions.AD_ENTITIES_BUSY:
      return setBusy(state);
    case Actions.AD_ENTITIES_UNBUSY:
      return setUnBusy(state);
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
